import styles from "./faq.module.css";

type Props = {
  question: string;
  answer: string;
};

function FaqCard({ question, answer }: Props) {
  return (
    <div className={styles.faqCard}>
      <h3 className={styles.question}>{question}</h3>
      <p className={styles.greyText}>{answer}</p>
    </div>
  );
}

export default FaqCard;
